// As recommended by https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html

// todo - review this RE (should it be anchored? does it exclude excluded characters - such as £?)
export const cognitoPasswordRE =
  /(?=(.*\d))(?=.*[!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?])(?=.*[a-z])(?=(.*[A-Z]))(?=(.*)).{8,}/;
